/**
 * In welche Richtung ein Rad- oder Kneifereignis den Grundriss zoomt.
 *
 * **Ein Trackpad-Kneifen ist kein Touch-Ereignis.** macOS meldet es als `wheel` mit gesetztem
 * `ctrlKey` — die Zweifingergeste läuft also durch denselben Pfad wie das Mausrad und nicht durch
 * die `touchmove`-Behandlung, die der Editor für Tablets hat. Deshalb entscheidet allein das
 * Vorzeichen von `deltaY`, und deshalb war das Kneifen verkehrt herum, obwohl der Touch-Pfad
 * daneben richtig rechnet.
 *
 * Das Vorzeichen bedeutet:
 *
 * | Geste | `deltaY` | erwartet |
 * |---|---|---|
 * | Finger zusammenziehen | positiv | kleiner |
 * | Finger spreizen | negativ | größer |
 * | Rad nach unten | positiv | kleiner |
 * | Rad nach oben | negativ | größer |
 *
 * Beide Eingaben zeigen also in dieselbe Richtung: Ein positives `deltaY` verkleinert. Die frühere
 * Fassung hatte es genau umgekehrt und vergrößerte beim Zusammenziehen.
 */

/** Wie stark ein einzelnes Ereignis wirkt. Klein, weil ein Kneifen viele davon sendet. */
const STEP = 0.01;

export const zoomFactorFor = (deltaY: unknown): number => {
    if (typeof deltaY !== 'number' || !Number.isFinite(deltaY) || deltaY === 0) {
        // Kein Ausschlag, keine Änderung. Ein Faktor von 1 lässt den Aufrufer rechnen, ohne dass er
        // den Sonderfall kennen muss.
        return 1;
    }

    return deltaY > 0 ? 1 - STEP : 1 + STEP;
};
